import React from 'react';

const TopicAdmin = () => {
    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-2">Topic Administration</h2>
            {/* Topic Admin controls */}
        </div>
    );
};

export default TopicAdmin;
